<template>
  <PaymentStatusView v-if="hasPaymentUid" />
  <IndexView v-else />
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import IndexView from "./IndexView.vue";
import PaymentStatusView from "./PaymentStatusView.vue";

const route = useRoute();

const hasPaymentUid = computed(() =>
  Boolean(String(route.query?.uid || "").trim()),
);
</script>
